
namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class PendingOrderProductsDialog extends Serenity.EntityDialog<PendingOrderProductsRow, any> {
        protected getFormKey() { return PendingOrderProductsForm.formKey; }
        protected getIdProperty() { return PendingOrderProductsRow.idProperty; }
        protected getLocalTextPrefix() { return PendingOrderProductsRow.localTextPrefix; }
        protected getNameProperty() { return PendingOrderProductsRow.nameProperty; }
        protected getService() { return PendingOrderProductsService.baseUrl; }
        protected getDeletePermission() { return PendingOrderProductsRow.deletePermission; }
        protected getInsertPermission() { return PendingOrderProductsRow.insertPermission; }
        protected getUpdatePermission() { return PendingOrderProductsRow.updatePermission; }

        protected form = new PendingOrderProductsForm(this.idPrefix);

    }
}